"use client";

import React from "react";
import { MapPin, Phone, Mail, ArrowUp, Award, ShieldCheck, Facebook, Instagram, Linkedin, CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="59502" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-4 w-24 bg-muted/20 animate-pulse rounded" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li className="text-sm text-muted-foreground/50 italic">
          Inga länkar tillgängliga
        </li>
      </ul>;
  }
  return <ul className="space-y-4">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-accent transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function SidfotInfo() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  const currentYear = new Date().getFullYear();
  return <section id="fotnot" className="dark bg-zinc-950 text-primary-foreground pt-20 pb-8 border-t border-border/10">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {}
          <div className="space-y-8">
            <Link to="/" className="block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609312/img/nordicgroundworks_logo_white.png" alt="Vandra Enkelt Logo" className="h-10 w-auto object-contain opacity-90 hover:opacity-100 transition-opacity" />
            </Link>
            
            <div className="space-y-6">
              <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
                Din guide till oförglömliga vandrings- och cykeläventyr i Europa. Vi skapar detaljerade digitala guider för den självständige resenären som vill upptäcka mer.
              </p>
              
              <div className="flex gap-4 pt-2">
                <div className="flex flex-col items-center gap-2 group">
                  <div className="p-2.5 rounded-full bg-secondary/30 text-muted-foreground group-hover:bg-accent group-hover:text-accent-foreground transition-all duration-300 border border-border/10">
                    <Award className="size-5" />
                  </div>
                  <span className="text-[10px] font-medium text-muted-foreground/60 uppercase tracking-wider group-hover:text-accent transition-colors">Premium</span>
                </div>
                <div className="flex flex-col items-center gap-2 group">
                  <div className="p-2.5 rounded-full bg-secondary/30 text-muted-foreground group-hover:bg-accent group-hover:text-accent-foreground transition-all duration-300 border border-border/10">
                    <ShieldCheck className="size-5" />
                  </div>
                  <span className="text-[10px] font-medium text-muted-foreground/60 uppercase tracking-wider group-hover:text-accent transition-colors">Tryggt</span>
                </div>
                <div className="flex flex-col items-center gap-2 group">
                  <div className="p-2.5 rounded-full bg-secondary/30 text-muted-foreground group-hover:bg-accent group-hover:text-accent-foreground transition-all duration-300 border border-border/10">
                    <CircleCheck className="size-5" />
                  </div>
                  <span className="text-[10px] font-medium text-muted-foreground/60 uppercase tracking-wider group-hover:text-accent transition-colors">GPX Ingår</span>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="space-y-6 bg-card p-6 rounded-xl border border-border/10">
            <h3 className="text-lg font-bold tracking-wider text-foreground uppercase border-b-2 border-accent pb-1 w-fit">Snabblänkar</h3>
            <MenuProvider menu_id="59" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-sm font-bold tracking-wider text-foreground uppercase border-b border-accent/20 pb-2 w-fit">Våra Guider</h3>
            <ul className="space-y-3">
              {["Vandringsguider", "Cykelguider", "Digitala Kartor", "Logistik & Tips", "Boenderekommendationer", "GPX-filer", "Säsongsguider"].map((service, i) => <li key={i} data-index={i}>
                  <Link to="#" className="text-sm text-muted-foreground hover:text-accent transition-colors flex items-center gap-2 group">
                    <span className="w-1 h-1 rounded-full bg-accent/40 group-hover:bg-accent transition-colors"></span>
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-sm font-bold tracking-wider text-foreground uppercase border-b border-accent/20 pb-2 w-fit">Kontakt</h3>
            <ul className="space-y-5">
              <li className="flex items-start gap-3 text-sm text-muted-foreground group">
                <MapPin className="size-5 text-accent/70 shrink-0 mt-0.5 group-hover:text-accent transition-colors" />
                <span className="group-hover:text-foreground transition-colors">
                  Stockholm, Sverige<br />
                  Digitala äventyr i Europa
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground group">
                <Phone className="size-5 text-accent/70 shrink-0 group-hover:text-accent transition-colors" />
                
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground group">
                <Mail className="size-5 text-accent/70 shrink-0 group-hover:text-accent transition-colors" />
                <Link to="mailto:hej@vandraenkelt.se" className="hover:text-accent transition-colors group-hover:text-foreground">
                  hej@vandraenkelt.se
                </Link>
              </li>
            </ul>
            
            <div className="pt-6 flex gap-4">
              <Link to="#" className="p-2 rounded-md bg-secondary/20 text-muted-foreground hover:bg-accent hover:text-accent-foreground transition-all duration-300" aria-label="Facebook">
                <Facebook className="size-4" />
              </Link>
              <Link to="#" className="p-2 rounded-md bg-secondary/20 text-muted-foreground hover:bg-accent hover:text-accent-foreground transition-all duration-300" aria-label="Instagram">
                <Instagram className="size-4" />
              </Link>
              <Link to="#" className="p-2 rounded-md bg-secondary/20 text-muted-foreground hover:bg-accent hover:text-accent-foreground transition-all duration-300" aria-label="LinkedIn">
                <Linkedin className="size-4" />
              </Link>
            </div>
          </div>
        </div>

        <Separator className="bg-border/10 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-xs text-muted-foreground/50 font-medium">
          <div className="flex flex-col md:flex-row items-center gap-3 md:gap-8">
            <span>&copy; {currentYear} Vandra Enkelt. Alla rättigheter förbehållna.</span>
            <div className="hidden md:block w-1 h-1 rounded-full bg-muted-foreground/30" />
            <div className="flex gap-6">
              <Link to="#" className="hover:text-accent transition-colors">Integritetspolicy</Link>
              <Link to="#" className="hover:text-accent transition-colors">Köpvillkor</Link>
            </div>
          </div>
          
          <Button variant="ghost" size="sm" onClick={scrollToTop} className="gap-2 hover:bg-secondary/30 hover:text-accent text-muted-foreground h-8 px-3 rounded-full border border-border/10">
            Till toppen
            <ArrowUp className="size-3.5" />
          </Button>
        </div>
      </div>
    </section>;
}